import { initHeader } from "./controls/header";
import { hidePreloader, showPreloader } from "./controls/preloader";
import { initReCapcha } from "./controls/recapcha";
import { initAppearanceEffect } from "./controls/appearance-effect";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
let isBlockLoader = false;

window.onpageshow = event => {
    if (event.persisted) {
        window.location.reload();
    }
};

window.onbeforeunload = () => {
    if (isBlockLoader) {
        isBlockLoader = false;
        return;
    }
    showPreloader();
};

document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);
    initAppearanceEffect();

    setTimeout(() => {
        hidePreloader();
        initReCapcha();
    }, 500);

    initHeader();
    document.querySelectorAll("a[href^=mailto],a[href^=tel],a[href^=whatsapp]").forEach(x =>
        x.addEventListener("click", e => {
            isBlockLoader = true;
        }),
    );
});